import React, { useEffect, useState } from 'react';
import { PageHeader } from 'antd';
import * as queryString from 'query-string';
import { RouteComponentProps } from 'react-router-dom';
import { JobSummary, Job } from '../../types/Job';
import { Client } from '../../types/Client';
import { JOB_MAP_OPERATION } from '../../mappers/job.mapper';
import { JobList, JobListSearchFilters } from '../../components/Job';
import JobController from '../../controllers/job.controller';
import ClientController from '../../controllers/client.controller';

const JobListContainer = ({
    history,
    match: { url },
    location: { search },
}: RouteComponentProps): React.ReactElement => {
    const [componentStatusFlags, setComponentStatusFlags] = useState<{ isLoadingData: boolean }>({
        isLoadingData: true,
    });

    const [appliedFilters, setAppliedFilters] = useState<any>(queryString.parse(search, { arrayFormat: 'bracket' }));
    const [clients, setClients] = useState<Client[]>([]);

    const [data, setData] = useState<{
        jobs: JobSummary[] | Job[];
        pagination: any;
    }>({
        jobs: [],
        pagination: {},
    });

    const setFiltersToApply = (filters: any, opts?: { isPaging: boolean }): void => {
        setAppliedFilters((prevAppliedFilters: any) => {
            const filterResult = opts && opts.isPaging ? { ...prevAppliedFilters, ...filters } : { ...filters };
            const query = queryString.stringify(filterResult, { arrayFormat: 'bracket' });
            history.push(`${url}?${query}`);
            return filterResult;
        });
    };

    const getAllJobs = async (): Promise<void> => {
        try {
            setComponentStatusFlags({ isLoadingData: true });
            const {
                jobs: jobList,
                _metadata: { pagination },
            } = await JobController.getAllJobs(appliedFilters, JOB_MAP_OPERATION.SUMARIZED);

            setData({
                jobs: jobList as JobSummary[],
                pagination,
            });
        } finally {
            setComponentStatusFlags({ isLoadingData: false });
        }
    };

    const getAllClients = async (): Promise<void> => {
        try {
            setComponentStatusFlags({ isLoadingData: true });
            const { list: clientList } = await ClientController.getAllClients(undefined, -1);
            setClients(clientList);
        } finally {
            setComponentStatusFlags({ isLoadingData: false });
        }
    };

    const onRelease = async (job: Job): Promise<void> => {
        setComponentStatusFlags({ isLoadingData: true });
        await JobController.releaseJob(job.id);
        await getAllJobs();
        setComponentStatusFlags({ isLoadingData: false });
    };

    useEffect(() => {
        getAllJobs();
        getAllClients();
    }, [appliedFilters]);

    return (
        <div className="shadow-sm">
            <PageHeader className="site-page-header py-2 justify-content-end" title={<p className="h5 m-0">Jobs</p>} />
            <JobListSearchFilters
                onSetSearchFilters={setFiltersToApply}
                initialFilters={appliedFilters}
                isLoadingData={componentStatusFlags.isLoadingData}
                clients={clients}
            />
            <JobList
                jobs={data.jobs}
                pagination={data.pagination}
                onPageChanges={setFiltersToApply}
                isLoadingData={componentStatusFlags.isLoadingData}
                onRelease={onRelease}
            />
        </div>
    );
};

export default JobListContainer;
